/**
 * cookie 模块提供 cookie 的封装
 * @module cookie
 */

import cookies from 'js-cookie';

export function getCookie (name) {
  return cookies.get(name);
}

export function setCookie (name, val, options) {
  return cookies.set(name, val, options);
}

export function removeCookie (name, options) {
  return cookies.remove(name, options);
}
